<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label class="form-label">Origin Point</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Origin Point"
                placeHolder="Type to search"
                :initVal="entity.originPoint"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="selectOrigin"
              ></autocomplete>
            </div>
              <div class="form-group">
                <label class="form-label">Destination Point</label>
                <autocomplete
                  :dataset="locationSearchResults"
                  title="Destination Point"
                  placeHolder="Type to search"
                  :initVal="entity.destinationPoint"
                  v-on:changing="data => locationSearchText = data"
                  :fnFormatText="displayLocation"
                  :fnSelectValue="displayLocation"
                  v-on:selection-made="selectDestination"
                ></autocomplete>
              </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="ptp-ext" class="form-label">External ID</label>
              <input type="text" class="form-control" id="ptp-ext" v-model="entity.externalId"/>
            </div>
            <div v-if="entity.id">
              <div class="form-group">
                <label class="form-label">Add Ports to Point-To-Port</label>
                <autocomplete
                  :dataset="ports"
                  title="Port Search"
                  placeHolder="Type to search"
                  :initVal="pointToPortToPortLocation"
                  v-on:changing="data => locationSearchText = data"
                  :fnFormatText="displayLocation"
                  :fnSelectValue="displayLocation"
                  v-on:selection-made="selectPort"
                ></autocomplete>
              </div>
              <vue-table
                v-on:table-delete-request="removeLocation"
                :showDelete="true"
                :tableData="pointToPortToPorts"
                tableTitle="Ports"
                :fields="[
                { header: 'Port', prop: obj => obj.port ? displayLocation(obj.port) : '' }
                ]"
              ></vue-table>
            </div>
            <div v-else class="mt-20 mb-15">
              <p>Once you have saved the Point To Port, you will be able to add Ports</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import HelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable.vue'
  import event from '../../../../event'
  export default {
    name: 'PointToPort',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        transformForUpdate: {
          originPoint: this.toMinus,
          destinationPoint: this.toMinus,
          externalId: this.toZero
        },
        newEntityScreen: 'Admin - Point To Ports',
        editEntityScreen: 'Admin - Edit/View Point To Port',
        tab: 'main',
        entity: {
          id: null,
          originPoint: null,
          destinationPoint: null,
          externalId: null
        },
        entityName: 'point-to-port',
        boxes: [],
        pointToPortToPorts: [],
        pointToPortToPortLocation: ''
      }
    },
    components: {
      Autocomplete,
      VueTable
    },
    computed: {
      isValid () {
        return this.entity.originPoint && this.entity.destinationPoint && this.entity.originPoint.id && this.entity.destinationPoint.id
      },
      storePointToPortToPorts () {
        return this.$store.getters['admin/pointToPortToPorts']
      }
    },
    methods: {
      findLocationInPortAreasToPortByIndex (locationsArr, loc) {
        return locationsArr.findIndex(({port}) => port.id === loc.id)
      },
      removeLocation ({ item, index }) {
        const i = this.findLocationInPortAreasToPortByIndex(this.pointToPortToPorts, item.port)
        if (item.id) {
          this.deleteRelatedEntity('point-to-port-to-port', item.id)
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'Port deleted' })
            this.pointToPortToPorts.splice(i, 1)
          })
          .catch(err => {
            event.$emit('toast', { type: 'error', message: 'Unable to delete Port; please try again or contact support' })
            console.log(err)
          })
        }
      },
      selectPort (l) {
        if (Object.keys(l).length > 0) {
          if (this.findLocationInPortAreasToPortByIndex(this.pointToPortToPorts, l) > -1) {
            event.$emit('toast', { type: 'warning', message: 'Point-To-Port already contains selected location' })
          } else {
            this.saveRelatedEntity('point-to-port-to-port', {
              id: null,
              pointToPort: this.entity.id,
              port: l
            }).then(({data}) => {
              event.$emit('toast', { type: 'success', message: 'Port added' })
              this.pointToPortToPorts.push(data)
            })
            .catch(err => {
              event.$emit('toast', { type: 'error', message: 'Unable to add Port; please try again or contact support' })
              console.log(err)
            })
          }
        }
        this.locationSearchText = ''
        this.locationSearchResults = []
        this.$nextTick(() => {
          this.portAreaLocation = ''
        })
      },
      selectOrigin (o) {
        this.entity.originPoint = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (p) {
        this.entity.destinationPoint = p
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      getBaseData () {
        return {
          id: null,
          originPoint: null,
          destinationPoint: null,
          externalId: null
        }
      },
      refresh () {
        this.pointToPortToPorts = this.storePointToPortToPorts
      }
    },
    mounted () {
      this.pointToPortToPorts = this.storePointToPortToPorts
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/PointToPort/PointToPort.vue